import classNames from "classnames";
import BasicPill from "PFApp/components/pills/basic_pill";
import Tooltip from "PFComponents/tooltip/tooltip";
import PropTypes from "prop-types";
import React from "react";

import { BAR_HEIGHT } from "../calendar";
import css from "./bars.module.scss";

const BasicBar = ({
  barRef,
  left,
  top,
  width,
  children,
  onClick,
  className,
  style,
  tooltipContent,
  tooltipModifiers,
  tooltipProps,
  onMouseEnter,
  onMouseLeave,
  onMouseDown
}) => {
  const handleClick = (event) => {
    event.stopPropagation();
    onClick && onClick(event);
  };

  const finalStyle = {
    transform: `translate(0px, ${top}px)`,
    left: `${left}px`,
    width,
    height: BAR_HEIGHT,
    ...style
  };

  const modifiers = [
    {
      name: "preventOverflow",
      options: {
        altBoundary: true
      }
    }
  ];

  if (tooltipModifiers) {
    modifiers.push(tooltipModifiers);
  }

  /* eslint-disable jsx-a11y/click-events-have-key-events */
  /* eslint-disable jsx-a11y/no-static-element-interactions */
  return (
    <Tooltip
      content={tooltipContent}
      placement="top"
      popperOptions={{
        modifiers
      }}
      {...tooltipProps}
    >
      <div
        ref={barRef}
        className={classNames(css.bar, className)}
        style={finalStyle}
        onClick={handleClick}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
        onMouseDown={onMouseDown}
      >
        {children || <BasicPill />}
      </div>
    </Tooltip>
  );
};

BasicBar.propTypes = {
  barRef: PropTypes.shape({ current: PropTypes.instanceOf(Element) }),
  width: PropTypes.number.isRequired,
  left: PropTypes.number.isRequired,
  top: PropTypes.number.isRequired,
  onClick: PropTypes.func,
  className: PropTypes.string,
  style: PropTypes.object,
  children: PropTypes.node,
  tooltipContent: PropTypes.node,
  tooltipModifiers: PropTypes.object,
  tooltipProps: PropTypes.object,
  onMouseEnter: PropTypes.func,
  onMouseLeave: PropTypes.func,
  onMouseDown: PropTypes.func
};

BasicBar.defaultProps = {
  tooltipProps: {}
};
BasicBar.defaultProps = {
  top: 0
};

export default BasicBar;
